
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 25 25","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M20.466 5.253c-5.11 3.133-8.817 7.085-10.483 9.069l-4.08-3.197-1.801 1.453 7.05 7.169c1.213-3.107 5.056-9.181 9.746-13.497l-.431-.997z","fill":"#FFF","fill-rule":"evenodd"}})])
          )
        }
      }
    